var render = function render(){var _vm=this,_c=_vm._self._c;return _c('unicom-layout-pagina',[_c('unicom-layout-home',{attrs:{"titulo":"RNP | Rede nacional de prestadores","codigoUnimed":_vm.zeroEsquerda(_vm.codigoUnimedUsuarioMixin),"nomeUnimed":_vm.letraMaiusculaCadaPalavra(_vm.unimedSelecionadaNomeMixin),"listaCartoes":_vm.listaTelasFilter},on:{"click-cartao":_vm.redirecionar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }